module.exports = __webpack_public_path__ + "static/img/banner2.dd43d8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2.jpg
// module id = y5LZ
// module chunks = 1